module.exports = __webpack_public_path__ + "static/assets/22bfe7e310b6ba9f35af4c43c9478512.svg";